// src/lib/notificationLinks.js
//
// Notification navigation allowlist (Patient Appointments Task 4).
//
// The API already sanitises links; the UI checks again so a notification can
// only ever navigate inside the patient portal. External URLs, protocol-relative
// URLs, javascript: links, query strings, fragments and unknown paths are
// refused. Appointment notifications always open the appointment detail.

const UUID = "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";

const SAFE_ROUTES = [
  new RegExp(`^/patient/appointments/${UUID}$`),
  /^\/patient\/appointments$/,
  new RegExp(`^/patient/tickets/${UUID}$`),
  /^\/patient\/tickets$/,
  /^\/patient\/invoices$/,
  /^\/patient\/doctor-requests$/,
  /^\/patient\/dashboard$/,
];

const UUID_ONLY = new RegExp(`^${UUID}$`);

export function isSafeNotificationRoute(path) {
  if (typeof path !== "string") return false;
  const value = path.trim();
  if (!value || value.length > 200 || /[?#\\\s:]/.test(value) || value.startsWith("//")) return false;
  return SAFE_ROUTES.some((pattern) => pattern.test(value));
}

export function notificationRoute(notification) {
  if (!notification) return null;
  if (notification.entity_type === "appointment" && UUID_ONLY.test(String(notification.entity_id || ""))) {
    return `/patient/appointments/${notification.entity_id}`;
  }
  return isSafeNotificationRoute(notification.action_url) ? notification.action_url.trim() : null;
}
